import { updateEntity, deleteEntity, addEntity } from "../API";

import { redirect } from "react-router-dom";
import { assert, StructError } from "superstruct";

export async function entityAction(
  request,
  params,
  schema,
  multiSelectFields = [],
  objectFields = [],
  jsonArray = [],
  numberFields = [],
  booleanFields = []
) {
  const formData = await request.formData();

  let entity = Object.fromEntries(formData);

  multiSelectFields.forEach((field) => {
    entity[field] = formData.getAll(field).map((i) => {
      return { id: i };
    });
  });

  objectFields.forEach((field) => {
    entity[field] = { id: entity[field] };
  });

  jsonArray.forEach((field) => {
    entity[field] = JSON.parse(entity[field]);
  });

  numberFields.forEach((field) => {
    const val = entity[field];
    entity[field] = val !== undefined && val !== "" ? parseInt(val, 10) : undefined;
  });

  booleanFields.forEach((field) => {
    entity[field] = entity[field] === "true";
  });

  if (params.id) entity.id = params.id;

  const urlSplit = request.url.split("/");

  const endpoint = urlSplit[urlSplit.length - 2];

  switch (request.method) {
    case "PUT": {
      const errors = hasErrors(entity, schema);
      if (errors) return errors;
      await updateEntity(endpoint, entity);
      break;
    }
    case "POST": {
      const errors = hasErrors(entity, schema);
      if (errors) return errors;
      await addEntity(endpoint, entity);
      break;
    }
    case "DELETE": {
      await deleteEntity(endpoint, entity);
      break;
    }
    default: {
      throw new Response("", { status: 405 });
    }
  }

  return redirect(`../${endpoint}`);
}

function hasErrors(user, schema) {
  try {
    assert(user, schema);
  } catch (err) {
    if (err instanceof StructError) {
      const fieldsErrors = err.failures().reduce(
        (acc, { path, message }) => ({
          ...acc,
          [path[0]]: message,
        }),
        {}
      );
      console.log(fieldsErrors);
      return fieldsErrors;
    }
  }
  return null;
}
